// import { bulletins, sectionMeta } from "../data/Knowledge";
// import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// /* AssochamBulletins.jsx
//    Listing page for Assocham's periodical bulletins.
//    Image banner + title hero; clickable banner cards open the
//    detail overview + download page (handled by the parent router). */
// export default function AssochamBulletins({ onOpen }) {
//   return (
//     <KnowledgeSection
//       section={sectionMeta.bulletins}
//       items={bulletins}
//       onOpen={onOpen}
//     />
//   );
// }




// new code 




import { useNavigate } from "react-router-dom";
import { bulletins, sectionMeta } from "../data/Knowledge";
import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

export default function AssochamBulletins() {
  const navigate = useNavigate();

  return (
    <KnowledgeSection
      section={sectionMeta.bulletins}
      items={bulletins}
      onOpen={(item) => navigate(`/knowledge/bulletins/${item.id}`)}
    />
  );
}